import { Chip, Grid, Link } from "@mui/material";
import Academic_Schedule_2019_20 from "../../assets/pdfs/academic/Academic_Schedule_2019-20.pdf";
import Academic_Schedule_2020_21 from "../../assets/pdfs/academic/Academic_Schedule_2020-21.pdf";
import Academic_Schedule_2021_22 from "../../assets/pdfs/academic/Academic_Schedule_2021-22.pdf";
import Academic_Schedule_2022_23 from "../../assets/pdfs/academic/Academic_Schedule_2022-23.pdf";
import Academic_Schedule_2023_24 from "../../assets/pdfs/academic/Academic_Schedule_2023-24.pdf";
import Academic_Schedule_2024_25 from "../../assets/pdfs/academic/Academic_Schedule_2024-25.pdf";
import Academic_Schedule_2025_26 from "../../assets/pdfs/academic/acad calendar event calAug-jan 25-26.pdf";



import ContentLayout from "../../components/ContentLayout";

type Props = {};

const years = [
   {
    year: "2025-26",
    committee_url: Academic_Schedule_2025_26,
  },
  {
    year: "2024-25",
    committee_url: Academic_Schedule_2024_25,
  },
  {
    year: "2023-24",
    committee_url: Academic_Schedule_2023_24,
  },
  {
    year: "2022-23",
    committee_url: Academic_Schedule_2022_23,
  },
  {
    year: "2021-22",
    committee_url: Academic_Schedule_2021_22,
  },
  {
    year: "2020-21",
    committee_url: Academic_Schedule_2020_21,
  },
  {
    year: "2019-20",
    committee_url: Academic_Schedule_2019_20,
  },
];

const AcademicSchedule = (props: Props) => {
  return (
    <ContentLayout
      children={
        <>
          <Grid container spacing={2} mt={2} style={{display:"flex", justifyContent:"center"}}>
            {years?.map((item) => (
              <Grid item key={item.year} xs="auto">
                <Chip
                  label={item.year}
                  variant="filled"
                  color="secondary"
                  component={Link}
                  href={item?.committee_url}
                  target={item?.committee_url === "#" ? "_self" : "_blank"}
                  sx={{
                    cursor: "pointer",
                    border: "2px solid",
                    padding: "8px 16px",
                    borderRadius: "16px",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      opacity: 0.8,
                      color: "inherit",
                      backgroundColor: "transparent",
                      border: "2px solid",
                      borderColor: "secondary.main",
                      "& .MuiChip-label": {
                        textDecoration: "underline",
                      },
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </>
      }
    />
  );
};

export default AcademicSchedule;
